import {
  SHOW_POI_DETAIL,
  SHOW_POI_ROUTE,
  SHOW_ADD_POI,
  SHOW_FOLDER_DETAIL,
  SCROLL_TO_DAY,
  SHOW_DAY_MODE_ON_MAP,
  LANGUAGE_DETECTED,
  VIEW_STATE,
  LOAD_DATA_FROM_LOCAL_STORAGE,
  SHOW_EDIT_MODE,
  RESET_ITINERARY,
  SHOW_TOAST,
  HIDDEN_TOAST,
  SET_POI_DETAIL_TAB,
  SHOW_ORDER_DETAIL,
  SHOW_NOTE_DETAIL
} from './action_types';

// init action
export * from './init_action';

// login action
export * from './login_action';

// trip ation
export * from './trip_action';

// collaboration action
export * from './collaborate_action';

// route action
export * from './route_action';

// collection action
export * from './collectionAction';

// poi bank action
export * from './poi_bank_action';

// view state
export const updateViewState = (state, parameters) => ({
  type: VIEW_STATE,
  // parameters os : for header view show url scheme link
  // parameters link : for header view show url scheme link
  // ex {os:'iOS',link:'funliday://funliday.com/itinerary?id=12345'}
  payload: { viewState: state, parameters }
});

// set access token
export const loadDataFromLocalStorage = (
  member,
  accessToken,
  isPlannerTool = false
) => ({
  type: LOAD_DATA_FROM_LOCAL_STORAGE,
  payload: { member, accessToken, isPlannerTool }
});

// show poi detail
export const showPoiDetail = (
  show,
  folderObjectId,
  poiObjectId,
  type,
  dataSource,
  location,
  segmentIndex
) => ({
  type: SHOW_POI_DETAIL,
  payload: {
    show,
    folderObjectId, // for collections
    poiObjectId,
    type,
    dataSource,
    location,
    segmentIndex
  }
});

export const showOrderDetail = (isShowOrderCard, orderId, poiObjectId) => ({
  type: SHOW_ORDER_DETAIL,
  payload: {
    isShowOrderCard,
    orderId,
    poiObjectId
  }
});

export const showNoteDetail = (isShowNoteDetail, poiObjectId) => ({
  type: SHOW_NOTE_DETAIL,
  payload: {
    isShowNoteDetail,
    poiObjectId
  }
});

export const setPoiDetailTab = segmentIndex => ({
  type: SET_POI_DETAIL_TAB,
  payload: { segmentIndex }
});

// show poi route
export const showPoiRoute = (show, selectedId) => ({
  type: SHOW_POI_ROUTE,
  payload: { show, selectedId }
});

// show poi create
export const showAddPoi = (
  show,
  tripObjectId,
  daySequence,
  poiSequenceIndex,
  previousPoiSequenceIndex,
  nexPoiSequenceIndex
) => ({
  type: SHOW_ADD_POI,
  payload: {
    show,
    tripObjectId,
    daySequence,
    poiSequenceIndex,
    previousPoiSequenceIndex,
    nexPoiSequenceIndex
  }
});

// show day mode on the map
export const showDayModeOnMap = day => ({
  type: SHOW_DAY_MODE_ON_MAP,
  payload: day
});

// show collections folder detail
export const showFolderDetail = (show, folderObjectId) => ({
  type: SHOW_FOLDER_DETAIL,
  payload: { show, folderObjectId }
});

// show poi route
export const showEditMode = () => ({
  type: SHOW_EDIT_MODE
});

export const resetItinerary = () => ({ type: RESET_ITINERARY });

// show poi route
export const showToast = (message, viewState) => {
  if (message) {
    return {
      type: SHOW_TOAST,
      payload: { toastMessage: message, toastViewState: viewState }
    };
  }
  return {
    type: SHOW_TOAST,
    payload: { viewState }
  };
};

export const hiddenToastOfItinerary = () => dispatch =>
  setTimeout(() => dispatch({ type: HIDDEN_TOAST }), 2000);

// scroll to day
export const scrollToDay = day => ({
  type: SCROLL_TO_DAY,
  payload: { day }
});

// react-intl
export const languageDetected = (locale, fullLocale, messageFileName) => ({
  type: LANGUAGE_DETECTED,
  payload: { locale, fullLocale, messageFileName }
});
